// extracted by mini-css-extract-plugin
export default {"collapse":"collapse_collapse__aGWh1","show":"collapse_show__q6LZi","collapsing":"collapse_collapsing__BDH1t"};